import React from 'react';
import logo from '../assets/images/mealpoint_logo.png';

/**
 * Logo oficial de MealPoint
 * Componente reutilizable con variantes de tamaño
 */
const Logo = ({ 
  size = 'medium', 
  showText = true, 
  className = '',
  style = {},
  textColor = '#27AE60' // Color por defecto del texto, puede ser 'white' para fondos oscuros
}) => {
  const sizes = {
    small: '40px',
    medium: '60px',
    large: '120px',
    xlarge: '200px',
  };

  const logoSize = sizes[size] || sizes.medium;

  return (
    <div 
      className={`mealpoint-logo ${className}`}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        ...style
      }}
    >
      <img 
        src={logo} 
        alt="MealPoint Logo" 
        style={{
          width: logoSize,
          height: logoSize,
          objectFit: 'contain',
          display: 'block',
          filter: 'drop-shadow(0 0 0 transparent)', // Elimina sombras si las tiene
          borderRadius: '12px'
        }}
      />
      {showText && (
        <span
          style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: size === 'small' ? '18px' : size === 'large' ? '36px' : size === 'xlarge' ? '48px' : '24px',
            fontWeight: 700,
            color: textColor,
            letterSpacing: '-0.5px',
          }}
        >
          MealPoint
        </span>
      )}
    </div>
  );
};

export default Logo;
